import { BonusCoinMappingsQueryKey } from '../../queryKey';
import {
  UseBonusCoinMappingsProps,
  UseBonusCoinMappingsQueryKey,
} from './props';
import { useQuery } from '@tanstack/react-query';
import { fetchBonusCoinMappings } from './service';
import {
  usePaginatedQuery,
  UsePaginatedQueryResponseProps,
} from '@starsoft/common/hooks';
import { GenericError, PaginatedResponse } from '@starsoft/common/models';
import { AxiosError } from 'axios';
import { useState } from 'react';
import { BonusCoinMapping } from '@/models/bonusCoinMapping';

export function useBonusCoinMappings({
  bonusId,
  enabled = true,
}: UseBonusCoinMappingsProps) {
  const [page, setPage] = useState(1);
  const queryKey: UseBonusCoinMappingsQueryKey = [
    BonusCoinMappingsQueryKey.Primary,
    {
      page,
      bonusId,
      limit: 5,
    },
  ];

  const { data, isPending, fetchStatus, ...infiniteQuery } = useQuery<
    PaginatedResponse<BonusCoinMapping>,
    AxiosError<GenericError>,
    PaginatedResponse<BonusCoinMapping>,
    UseBonusCoinMappingsQueryKey
  >({
    queryKey,
    enabled: enabled && !!bonusId,
    queryFn: fetchBonusCoinMappings,
  });

  const paginatedQueryCallbacks: UsePaginatedQueryResponseProps =
    usePaginatedQuery({ data, page, setPage });

  return {
    ...infiniteQuery,
    bonusCoinMappings: data?.data,
    metadata: data?.metadata,
    isPending: isPending && fetchStatus !== 'idle',
    page,
    data,
    ...paginatedQueryCallbacks,
  };
}
